/* IMÁGENES PREVIEW*/
import ImageArena from '../assets/images/arena-destacado.png'
import ImageCemento  from '../assets/images/cemento-destacado.png'
import ImageLadrillos from '../assets/images/ladrillos-destacado.png'
import ImageAditivos from '../assets/images/aditivos.png';
import ImageViguetas from '../assets/images/viguetas.png';
import ImageHierros from '../assets/images/hierros.png';
/* IMÁGENES DETALLE */
import ImageArenaDetail from '../assets/images/arena-detalle.png';
import ImageCementoDetail from '../assets/images/cemento-detalle.png';
import ImageHierrosDetail from '../assets/images/hierros-detalle.png';
import ImageLadrillosDetail from '../assets/images/ladrillos-detalle.png';
import ImageViguetasDetail from '../assets/images/viguetas-detalle.png';
import ImageAditivosDetail from '../assets/images/aditivos-detalle.png';

export const PRODUCTS_NAME = ['Aditivos e impermeabilizantes', 'Áridos', 'Bolsas (cemento y derivados)', 'Hierros y Mallas', 'Ladrillos', 'Viguetas'];

export const DESTACADOS = [
    {id: 'aridos', image: ImageArena},
    {id: 'cemento-y-derivados', image: ImageCemento},
    {id: 'ladrillos', image: ImageLadrillos}
]

export const FULL_PRODUCTS = [
    {   id: 'cemento-y-derivados', 
        title: 'Cemento y Derivados', 
        description: 'Variedad de bolsas para obras de ingeniería, arquitectura, estructuras, albañilería y mucho más.',
        image: ImageCemento, 
        list: [ 'Cemento x50kg',
                'Cemento x10kg',
                'Cal común x20kg',
                'Cal Milagro x25kg',
                'Hidralit / Plasticor (cto. de albañilería) x40kg',
                'Klaukol Impermeable x30kg',
                'Construkor / Weber Basic x30kg',
                'Yeso Tuyango  x30kg'],
        imageDetail: ImageCementoDetail
    },
    {   id: 'ladrillos', 
        title: 'Ladrillos', 
        image: ImageLadrillos, 
        list: ['Ladrillo Común',
        'Ladrillo ½ Vista',
        'Ladrillo Vista',
        'Hueco 8x18x33cm',
        'Hueco 12x18x33cm',
        'Hueco 18x18x33cm',
        'Portante 12x19x33cm',
        'Portante 18x19x33cm',
        'Bloque techo 12cm',
        'Bloque techo 10cm'],
        imageDetail: ImageLadrillosDetail
    },
    {   id: 'aridos', 
        title: 'Áridos',
        image: ImageArena,
        list: ['Bolsón de Arena',
        'Bolsón de Arena x1/2kg',
        'Bolsita de Arena',
        'Bolsón de Piedra',
        'Bolsón de Piedra x1/2kg',
        'Bolsita de Piedra',
        'Bolsón de Cascote',
        'Bolsón de Cascote x1/2kg',
        'Bolsita de Cascote',
        'Bolsón de Leca',
        'Bolsita de Leca'],
        imageDetail: ImageArenaDetail
    },
    {   id: 'aditivos-e-impermeabilizantes', title: 'Aditivos e Impermeabilizantes', image: ImageAditivos, 
        list: ['Hidrófugo Ceresita x1kg',
        'Hidrófugo Ceresita x4kg',
        'Hidrófugo Ceresita x10kg',
        'Hidrófugo Ceresita x20kg',
        'Hidrófugo Ceresita x200kg',
        'Tacurú x1lts',
        'Tacurú x4lts',
        'Tacurú x10lts',
        'Tacurú x20lts',
        'Tacurú x200lts',
        'Membrana 4mm',
        'Pintura Asfáltica'],
        imageDetail: ImageAditivosDetail
    },
    {   id: 'hierros-y-mallas',
        title: 'Hierros y Mallas',
        image: ImageHierros,
        list: [ 'Hierro 4 / 6 / 8 / 10 / 12 / 16 / 20 / 25',
                'Malla 15X15 2X5 liv 4mm',
                'Malla 15x15 2x5 liv 5,5mm',
                'Alambre de Fardo',
                'Clavo 1 1/2',
                'Clavo 2',
                'Clavo 2 1/2',
                'Clavo 3',
                'Clavo 4',
                'Metal desplegado'
            ],
        imageDetail: ImageHierrosDetail
    },
    {   id: 'viguetas',
        title: 'Viguetas', 
        image: ImageViguetas, 
        description: 'Medidas:',
        list: [ '2,00m',
                '2,20m',
                '2,40m',
                '2,60m',
                '2,80m',
                '3,00m',
                '3,20m',
                '3,40m',
                '3,60m',
                '3,80m',
                '4,00m',
                '4,20m',
                '4,40m',
                '4,60m',
                '4,80m',
                '5,00m',
                '5,20m',
                '5,40m',
                '5,60m'
            ],
        imageDetail: ImageViguetasDetail
    },
]

export const getProductById = (id) => FULL_PRODUCTS.find(i => i.id === id);

export const getProductByText = (text) => {
        let aux;
        console.log("texto: "+ text)
        const result = FULL_PRODUCTS.map(i => {
            aux = i.title.split(' ').map(i => i.toLowerCase());
            console.log(aux);
            if(aux.includes(text)){
                console.log("entré")
                return i;                
            }
        })
        console.log('result:');
        console.log(result);
        const filteredResult = result.find(i => i !== undefined);
        console.log('filtered results: ');
        console.log(filteredResult)
        if(filteredResult === undefined){
            return -1;
        } else return filteredResult.id;
}